import React, { useCallback, useEffect, useState } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../../../components/table/tablePagination";
import toast from "react-hot-toast";
import { FiFilter } from "react-icons/fi";
import DefaultButton from "../../../../components/buttons/defaultButton";
import { getSessionList } from "../../../../../services/workspace/session.service";
import { DefaultSelectFilter } from "../../../../components/inputs/defaultSelectFilter";
import ExaminationReportTable from "./components/table";
import { examinationReport, examinationReportExport } from "../../../../../services/workspace/report.service";
import DefaultSearchSelectInput from "../../../../components/inputs/defaultSearchSelectInput";
// Note: examination.service imports removed as they are not available for HR management system
import { convertToLabelValue } from "../../../../../utils/common";
// Note: _fetchClasses import removed as class functionality is not available for HR management system
import { PiExport } from "react-icons/pi";

const items = [
  { label: "Home", path: "/" },
  { label: "Reports", path: "/reports" },
  { label: "Examination Reports" },
];

const ExaminationReports = () => {
  const { limit } = useSelector((state) => state.global);
  const [search, setSearch] = useState("");
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const [selectClass, setSelectClass] = useState([]);
  const [selectExamType, setSelectExamType] = useState([]);
  const dispatch = useDispatch();
  // Note: classes removed as class functionality is not available for HR management system
  const [examType, setExamType] = useState([]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => !prev);
  };

  const fetchData = useCallback(() => { 
    if (selectClass && selectClass.id && selectExamType && selectExamType.id) {
      setLoading(true); 

      examinationReport({
        class_id: selectClass.id,
        exam_type_id: selectExamType.id,
        search,
        page: currentPage,
        limit,
      })
        .then((response) => {
          setTableData(response.data);
          setTotalData(response.total);
        })
        .catch((error) => {
          toast.error("Failed to fetch session data!");
          console.error("Error fetching data: ", error);
        })
        .finally(() => setLoading(false)); // Ensure loading state is handled correctly
    }
  }, [search, currentPage, limit, selectClass, selectExamType]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchData();
    }, 500); // Prevent excessive API calls while typing

    return () => clearTimeout(delayDebounce);
  }, [search, currentPage, limit, selectClass, selectExamType]);

  const fetchExamType = () => {
    if (selectClass && selectClass.id) {
      setLoading(true);
      // Note: getExaminationType removed as examination.service is not available for HR management system
      Promise.resolve({ data: [] })
        .then((response) => {
          
       
          const examTypeData = convertToLabelValue(response.data);
          setExamType(examTypeData);
        
        })
        .catch((error) => {
          toast.error("Failed to fetch the Examination data!");
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    fetchExamType();
    
  }, [selectClass]);

  // Note: _fetchClasses dispatch removed as class functionality is not available for HR management system

  const callback = (error = false, response = null) => {
    if (error) {
      toast.error("File download failed!");
      return;
    }
    if (response) {
      // window.location.href = response;
      window.open(response, "_blank");
    } else {
      toast.error("File download failed!");
    }
  };

  const handleExportDownload = async () => { 
    // const fetchFunction =
    //   type === "staff" ? staffAttendanceReport : studentAttendanceReport;

    examinationReportExport(
        {
          class_id: selectClass.id,
          exam_type_id: selectExamType.id,
          search,
          page: currentPage,
          limit,
            export:true
          }
        
    )
      .then((response) => {
        callback(false, response);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(`Failed to fetch   data!`);
        console.error(`Error fetching   data: `, error);
      });
    //  if (response) {
    //      callback(false, response);
    //  }
  };

  return (
    <div className="flex flex-col shadow-md">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={true}
        onSearchChange={handleSearchChange}
        isFilter={false}
        buttons={
          <div className="flex gap-2">
            <DefaultButton
              icon={<FiFilter />}
              iconClass="text-md"
              variant="primary"
              onClick={toggleFilterVisibility}
            />
            <div className=" ">
            <DefaultButton
            name={"Export"}
              icon={<PiExport />}
              iconClass="text-md"
              variant="primary"
              onClick={handleExportDownload}
            />
          </div>
          </div>
        }
      />

      <div className="flex flex-col">
        {isFilterVisible && (
          <div
            className="flex flex-row gap-2 px-4 py-2 text-theme font-bold
           items-center bg-white my-1"
          >
            <h2>Filters</h2>

            {/* <DefaultSelectFilter
              className="bg-light hover:bg-bghoverlight px-2 rounded-md flex flex-row gap-1"
              label="User Type"
              options={[
                { label: "Staff", value: "desc" },
                { label: "Students", value: "asc" },
              ]}
              name="sortBy"
              defaultSelect={true}
              // onChange={handleSelectChange}
              // error={isError}
              errorMsg="Please select an option"
            /> */}
            <label>Class</label>
            <DefaultSearchSelectInput
              id={"class_id"}
              name={"class_id"}
              // Note: classes removed as class functionality is not available
              options={[]}
              onChange={(e) => {
                setSelectClass(e);
              }}
            />
            <label>Exam Type</label>
            <DefaultSearchSelectInput
              id={"exam_type"}
              name={"exam_type"}
              options={examType}
              onChange={(e) => {
                setSelectExamType(e);
              }}
            />

            {/* <DefaultSelectFilter
              className="bg-light hover:bg-bghoverlight px-2 rounded-md flex flex-row gap-1"
              label="Date Range"
              options={[
                { label: "From", value: "desc" },
                { label: "To", value: "asc" },
              ]}
              name="sortBy"
              defaultSelect={true}
              // onChange={handleSelectChange}
              // error={isError}
              errorMsg="Please select an option"
            /> */}
          </div>
        )}

        <ExaminationReportTable
          setTotalData={setTotalData}
          loading={loading}
          search={search}
          data={tableData}
        />

        {/* Pagination component */}
        <PaginationComponent
          itemPerPage={limit}
          currentPage={currentPage}
          totalItems={totalData}
          paginate={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default ExaminationReports;
